import React, { useEffect, useState } from 'react'
import { ecommerceInterface } from '@cbgms/api/modules/customers'
import EmailApprovalIcon from '@carsys/ui/src/icons/EmailApprovalIcon'
import { Box } from '@mui/material'
interface StatusBarProps {
  status: 'emailSent' | 'orderConfirmed' | 'ACTIVATED' | 'UNKNOWN' | string
}

interface CustomerStatusProps {
  eData: ecommerceInterface | null
}

const StatusBar: React.FC<StatusBarProps> = ({ status }) => {
  const getStatusStyle = () => {
    switch (status) {
      case 'EMAIL_SENT':
        return { width: '33.33%', backgroundColor: 'blue' }
      case 'ORDER_CONFIRMED':
        return { width: '66.67%', backgroundColor: 'orange' }
      case 'AUTH0_UPDATED':
      case 'AUTH0_COMPLETED':
      case 'PACKAGE_SUBSCRIBED':
        return { width: '66.67%', backgroundColor: 'orange' }
      case 'OFFER_ACCEPTED':
        return { width: '66.67%', backgroundColor: 'orange' }
      case 'COMPLETED':
        return { width: '100%', backgroundColor: 'green' }
      default:
        return { width: '0%', backgroundColor: 'transparent' }
    }
  }

  return (
    <div
      style={{
        width: '100%',
        height: '20px',
        backgroundColor: 'white',
        border: '1px solid white',
        position: 'relative',
        margin: '10px 0'
      }}
    >
      <div style={{ height: '100%', transition: 'width 0.3s', ...getStatusStyle() }} />
      <div style={{ position: 'absolute', left: '33.33%', top: 0, bottom: 0, width: '2px', backgroundColor: 'white' }} />
      <div style={{ position: 'absolute', left: '66.67%', top: 0, bottom: 0, width: '2px', backgroundColor: 'white' }} />
    </div>
  )
}

const CustomerStatus: React.FC<CustomerStatusProps> = ({ eData }) => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (eData) {
      setLoading(false)
    }
  }, [eData])

  if (loading) {
    return <div>Loading...</div>
  }

  if (!eData) {
    return <div>Status: Data not available</div>
  }

  const getStatusMessage = () => {
    switch (eData.ActivationStatus) {
      case 'EMAIL_SENT':
        return `Email sent on (${eData.EmailSentDate})`
      case 'ORDER_CONFIRMED':
        return 'Order Confirmed'
      case 'AUTH0_UPDATED':
        return 'Order Confirmed'
      case 'AUTH0_COMPLETED':
        return 'Order Confirmed'
      case 'PACKAGE_SUBSCRIBED':
        return 'Order Confirmed'
      case 'OFFER_ACCEPTED':
        return 'Order Confirmed'
      case 'COMPLETED':
        return `${eData.ModuleName}: Activated`
      default:
        return 'Status: Unknown'
    }
  }

  return (
    <div>
      <StatusBar status={eData.ActivationStatus} />
      <div>{getStatusMessage()}</div>
      <Box display='flex' alignItems='center' style={{ marginTop: '8px' }}>
        <EmailApprovalIcon />: {eData.EmailId}
      </Box>
    </div>
  )
}

export default CustomerStatus
